const labourDetailedRateCard = {
  key: "labour",
  title: "Labour Detailed Rate Card",
  note:
    "Indicative labour pricing. Final charges can vary by city, floor level, load type, work hours, urgency, and number of workers required.",
  sections: [
    {
      title: "Helpers",
      items: [
        { name: "Helper - Half day", price: "₹499 per shift" },
        { name: "Helper - Full day", price: "₹799 per shift" },
      ],
    },
    {
      title: "General Labour",
      items: [
        { name: "General labour - Half day", price: "₹649 per shift" },
        { name: "General labour - Full day", price: "₹999 per shift" },
      ],
    },
    {
      title: "Movement Work",
      items: [
        { name: "Loading / unloading support", price: "₹699 onwards" },
        { name: "Material shifting support", price: "₹699 onwards" },
        { name: "In-building heavy item movement", price: "₹799 onwards" },
      ],
    },
  ],
};

export default labourDetailedRateCard;